// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---- from App.css lines 6085-6099 ---- */
/* ===== CAMPIONATI ===== */
.championship-card {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 12px;
  box-shadow: var(--shadow);
  transition: transform .2s ease, border-color .2s ease;
}

.championship-card:hover {
  transform: translateY(-3px);
  border-color: rgba(192, 255, 3, 0.45);
}

/* ---- from App.css lines 6699-6881 ---- */
/* === Championships: layout rinnovato === */
.cr-grid--champ {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media (max-width: 1100px) {
  .cr-grid--champ {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 720px) {
  .cr-grid--champ {
    grid-template-columns: 1fr;
  }
}

.championship-card {
  display: grid;
  gap: 12px;
}

/* Header card con immagine mostrata intera */
.cr-hero {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  width: 92%;
}

.cr-photo {
  width: 100%;
  height: 190px;
  /* altezza visibile ma non enorme */
  border-radius: 12px;
  border: 1px solid var(--line);
  background: rgba(255, 255, 255, .03);
  display: grid;
  place-items: center;
  overflow: hidden;
}

.cr-photo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  /* <<< mostra l’immagine intera, non tagliata */
}

.cr-photo.no-photo {
  color: var(--muted);
  font-size: .9rem;
}

.cr-hero-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.cr-hero-titles .cr-title {
  color: #fff;
  font-weight: 900;
  margin: 0 0 4px;
}

.cr-hero-actions {
  display: flex;
  gap: 8px;
}

.btn-ghost.small,
.btn-primary.small,
.btn-danger.small {
  padding: 6px 10px;
  border-radius: 10px;
  font-size: .88rem;
}

/* Blocco Formule */
.formula-block {
  background: var(--glass);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 12px;
  width: 92%;
}

.formula-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.formula-title {
  color: var(--brand);
  font-weight: 800;
  letter-spacing: .4px;
}

.formula-add {
  display: flex;
  gap: 8px;
  align-items: center;
  min-width: 320px;
}

@media (max-width: 520px) {
  .formula-add {
    width: 100%;
    min-width: 0;
  }
}

.formula-input {
  min-width: 200px;
}

.formula-list {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.formula-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid var(--line);
  background: rgba(255, 255, 255, .06);
}

.formula-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--brand);
  box-shadow: 0 0 10px rgba(192, 255, 3, .4);
}

.formula-text {
  font-weight: 800;
  color: #fff;
  letter-spacing: .2px;
}

.btn-icon {
  background: transparent;
  border: none;
  color: var(--muted);
  font-size: 16px;
  line-height: 1;
  padding: 0 2px;
  cursor: pointer;
}

.btn-icon:hover {
  color: #fff;
}

.formula-empty {
  border: 1px dashed var(--line);
  background: rgba(255, 255, 255, .03);
  border-radius: 10px;
  padding: 10px;
  text-align: center;
}

@media (max-width: 720px) {
  .cr-hero {
    width: 100%;
  }

  .formula-block {
    width: 100%;
  }
}

/* ---- from App.css lines 8987-9405 ---- */
/* ===== PREMIUM CHAMPIONSHIPS PAGE STYLES ===== */

/* Championships Header */
.championships-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  padding: 24px;
  background: linear-gradient(135deg, rgba(192, 255, 3, 0.08), rgba(192, 255, 3, 0.02));
  border: 1px solid rgba(192, 255, 3, 0.2);
  border-radius: 16px;
  backdrop-filter: blur(10px);
}

.championships-header-content {
  flex: 1 1;
}

.championships-stats {
  display: flex;
  gap: 20px;
}

/* Championship Form Container */
.championship-form-container {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  margin-bottom: 32px;
  overflow: hidden;
}

.championship-form-premium {
  padding: 24px;
}

.form-row-championship {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  align-items: start;
}

.form-col-championship-name {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-col-championship-photo {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dz-premium {
  border: 2px dashed var(--line);
  background: var(--glass);
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dz-premium:hover {
  border-color: rgba(192, 255, 3, 0.5);
  background: rgba(192, 255, 3, 0.05);
}

.dz-premium.has-preview {
  padding: 12px;
}

/* Championships List Header */
.championships-list-header {
  margin-bottom: 24px;
}

/* Championships Grid Premium */
.championships-grid-premium {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 24px;
  margin-bottom: 40px;
}

/* Championship Card Premium */
.championship-card-premium {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));
  border: 1px solid var(--line);
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.4s ease;
  position: relative;
  display: flex;
  flex-direction: column;
}

.championship-card-premium::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(192, 255, 3, 0.08), transparent);
  opacity: 0;
  transition: opacity 0.4s ease;
  pointer-events: none;
  z-index: 1;
}

.championship-card-premium:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
  border-color: rgba(192, 255, 3, 0.4);
}

.championship-card-premium:hover::before {
  opacity: 1;
}

/* Championship Hero */
.championship-hero {
  position: relative;
  height: 200px;
  background: linear-gradient(135deg, rgba(192, 255, 3, 0.1), rgba(192, 255, 3, 0.02));
  overflow: hidden;
}

.championship-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.championship-card-premium:hover .championship-img {
  transform: scale(1.08);
}

.championship-no-photo {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--muted);
  background: var(--glass);
}

.championship-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, transparent 50%, rgba(0, 0, 0, 0.7));
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 16px;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 2;
}

.championship-card-premium:hover .championship-overlay {
  opacity: 1;
}

.btn-delete-overlay {
  background: rgba(255, 107, 107, 0.9);
  color: white;
  border: 1px solid rgba(255, 107, 107, 0.3);
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 700;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  backdrop-filter: blur(10px);
}

.btn-delete-overlay:hover:not(:disabled) {
  background: rgba(255, 107, 107, 1);
  transform: scale(1.05);
}

.btn-delete-overlay:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Championship Content */
.championship-content {
  padding: 20px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  z-index: 2;
}

.championship-header-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--line);
}

.championship-name {
  font-size: 1.4rem;
  font-weight: 900;
  margin: 0;
  color: var(--fg);
  letter-spacing: -0.3px;
  line-height: 1.2;
}

.championship-date {
  font-size: 0.85rem;
  color: var(--muted);
  font-weight: 600;
}

/* Formulas Section */
.formulas-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1;
}

.formulas-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--brand);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.formula-count {
  background: rgba(192, 255, 3, 0.15);
  color: var(--brand);
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 800;
}

.formulas-empty {
  text-align: center;
  padding: 20px;
  color: var(--muted);
  font-size: 0.9rem;
  background: rgba(255, 255, 255, 0.02);
  border: 1px dashed var(--line);
  border-radius: 8px;
}

.formulas-list-premium {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.formula-badge-premium {
  display: flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, rgba(192, 255, 3, 0.15), rgba(192, 255, 3, 0.08));
  border: 1px solid rgba(192, 255, 3, 0.3);
  padding: 6px 10px 6px 12px;
  border-radius: 999px;
  transition: all 0.3s ease;
}

.formula-badge-premium:hover {
  background: linear-gradient(135deg, rgba(192, 255, 3, 0.2), rgba(192, 255, 3, 0.12));
  transform: translateY(-1px);
}

.formula-badge-text {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--brand);
  letter-spacing: 0.3px;
}

.formula-badge-remove {
  background: transparent;
  border: none;
  color: var(--brand);
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border-radius: 50%;
}

.formula-badge-remove:hover:not(:disabled) {
  background: rgba(255, 107, 107, 0.2);
  color: var(--down);
  transform: rotate(90deg);
}

.formula-badge-remove:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Formula Add Premium */
.formula-add-premium {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid var(--line);
}

.formula-input-premium {
  flex: 1 1;
  background: var(--glass);
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 10px 14px;
  color: var(--fg);
  font-size: 0.9rem;
  outline: none;
  transition: all 0.3s ease;
}

.formula-input-premium:focus {
  border-color: rgba(192, 255, 3, 0.6);
  box-shadow: 0 0 0 3px rgba(192, 255, 3, 0.1);
}

.formula-input-premium:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-add-formula {
  background: linear-gradient(135deg, var(--brand), #a8ff00);
  color: #0a0a0a;
  border: none;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
  box-shadow: 0 2px 8px rgba(192, 255, 3, 0.3);
}

.btn-add-formula:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 4px 12px rgba(192, 255, 3, 0.4);
}

.btn-add-formula:active:not(:disabled) {
  transform: translateY(0) scale(1);
}

.btn-add-formula:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Responsive Championships */
@media (max-width: 768px) {
  .championships-header {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .championships-stats {
    width: 100%;
    justify-content: center;
  }

  .championships-grid-premium {
    grid-template-columns: 1fr;
  }

  .form-row-championship {
    grid-template-columns: 1fr;
  }

  .championship-hero {
    height: 160px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/legacy/championships-legacy.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C,2BAA2B;AAC3B;EACE,yFAAyF;EACzF,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA,2CAA2C;AAC3C,4CAA4C;AAC5C;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,6BAA6B;EAC7B,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;;EAGE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,2CAA2C;AAC3C,kDAAkD;;AAElD,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,qFAAqF;EACrF,wCAAwC;EACxC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,yFAAyF;EACzF,6BAA6B;EAC7B,mBAAmB;EACnB,UAAU;EACV,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,yFAAyF;EACzF,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yEAAyE;EACzE,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,oFAAoF;EACpF,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2EAA2E;EAC3E,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,UAAU;EACV,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qFAAqF;EACrF,wCAAwC;EACxC,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,oFAAoF;EACpF,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0DAA0D;EAC1D,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ---- from App.css lines 6085-6099 ---- */\n/* ===== CAMPIONATI ===== */\n.championship-card {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: 12px;\n  box-shadow: var(--shadow);\n  transition: transform .2s ease, border-color .2s ease;\n}\n\n.championship-card:hover {\n  transform: translateY(-3px);\n  border-color: rgba(192, 255, 3, 0.45);\n}\n\n/* ---- from App.css lines 6699-6881 ---- */\n/* === Championships: layout rinnovato === */\n.cr-grid--champ {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n@media (max-width: 1100px) {\n  .cr-grid--champ {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 720px) {\n  .cr-grid--champ {\n    grid-template-columns: 1fr;\n  }\n}\n\n.championship-card {\n  display: grid;\n  gap: 12px;\n}\n\n/* Header card con immagine mostrata intera */\n.cr-hero {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n  width: 92%;\n}\n\n.cr-photo {\n  width: 100%;\n  height: 190px;\n  /* altezza visibile ma non enorme */\n  border-radius: 12px;\n  border: 1px solid var(--line);\n  background: rgba(255, 255, 255, .03);\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n}\n\n.cr-photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  /* <<< mostra l’immagine intera, non tagliata */\n}\n\n.cr-photo.no-photo {\n  color: var(--muted);\n  font-size: .9rem;\n}\n\n.cr-hero-info {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.cr-hero-titles .cr-title {\n  color: #fff;\n  font-weight: 900;\n  margin: 0 0 4px;\n}\n\n.cr-hero-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.btn-ghost.small,\n.btn-primary.small,\n.btn-danger.small {\n  padding: 6px 10px;\n  border-radius: 10px;\n  font-size: .88rem;\n}\n\n/* Blocco Formule */\n.formula-block {\n  background: var(--glass);\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 12px;\n  width: 92%;\n}\n\n.formula-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.formula-title {\n  color: var(--brand);\n  font-weight: 800;\n  letter-spacing: .4px;\n}\n\n.formula-add {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  min-width: 320px;\n}\n\n@media (max-width: 520px) {\n  .formula-add {\n    width: 100%;\n    min-width: 0;\n  }\n}\n\n.formula-input {\n  min-width: 200px;\n}\n\n.formula-list {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.formula-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  border: 1px solid var(--line);\n  background: rgba(255, 255, 255, .06);\n}\n\n.formula-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 999px;\n  background: var(--brand);\n  box-shadow: 0 0 10px rgba(192, 255, 3, .4);\n}\n\n.formula-text {\n  font-weight: 800;\n  color: #fff;\n  letter-spacing: .2px;\n}\n\n.btn-icon {\n  background: transparent;\n  border: none;\n  color: var(--muted);\n  font-size: 16px;\n  line-height: 1;\n  padding: 0 2px;\n  cursor: pointer;\n}\n\n.btn-icon:hover {\n  color: #fff;\n}\n\n.formula-empty {\n  border: 1px dashed var(--line);\n  background: rgba(255, 255, 255, .03);\n  border-radius: 10px;\n  padding: 10px;\n  text-align: center;\n}\n\n@media (max-width: 720px) {\n  .cr-hero {\n    width: 100%;\n  }\n\n  .formula-block {\n    width: 100%;\n  }\n}\n\n/* ---- from App.css lines 8987-9405 ---- */\n/* ===== PREMIUM CHAMPIONSHIPS PAGE STYLES ===== */\n\n/* Championships Header */\n.championships-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  padding: 24px;\n  background: linear-gradient(135deg, rgba(192, 255, 3, 0.08), rgba(192, 255, 3, 0.02));\n  border: 1px solid rgba(192, 255, 3, 0.2);\n  border-radius: 16px;\n  backdrop-filter: blur(10px);\n}\n\n.championships-header-content {\n  flex: 1;\n}\n\n.championships-stats {\n  display: flex;\n  gap: 20px;\n}\n\n/* Championship Form Container */\n.championship-form-container {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  padding: 0;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  margin-bottom: 32px;\n  overflow: hidden;\n}\n\n.championship-form-premium {\n  padding: 24px;\n}\n\n.form-row-championship {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  align-items: start;\n}\n\n.form-col-championship-name {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-col-championship-photo {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.dz-premium {\n  border: 2px dashed var(--line);\n  background: var(--glass);\n  border-radius: 12px;\n  padding: 20px;\n  text-align: center;\n  min-height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.dz-premium:hover {\n  border-color: rgba(192, 255, 3, 0.5);\n  background: rgba(192, 255, 3, 0.05);\n}\n\n.dz-premium.has-preview {\n  padding: 12px;\n}\n\n/* Championships List Header */\n.championships-list-header {\n  margin-bottom: 24px;\n}\n\n/* Championships Grid Premium */\n.championships-grid-premium {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n  gap: 24px;\n  margin-bottom: 40px;\n}\n\n/* Championship Card Premium */\n.championship-card-premium {\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  overflow: hidden;\n  transition: all 0.4s ease;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.championship-card-premium::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, rgba(192, 255, 3, 0.08), transparent);\n  opacity: 0;\n  transition: opacity 0.4s ease;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.championship-card-premium:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);\n  border-color: rgba(192, 255, 3, 0.4);\n}\n\n.championship-card-premium:hover::before {\n  opacity: 1;\n}\n\n/* Championship Hero */\n.championship-hero {\n  position: relative;\n  height: 200px;\n  background: linear-gradient(135deg, rgba(192, 255, 3, 0.1), rgba(192, 255, 3, 0.02));\n  overflow: hidden;\n}\n\n.championship-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.4s ease;\n}\n\n.championship-card-premium:hover .championship-img {\n  transform: scale(1.08);\n}\n\n.championship-no-photo {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--muted);\n  background: var(--glass);\n}\n\n.championship-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to bottom, transparent 50%, rgba(0, 0, 0, 0.7));\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  padding: 16px;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  z-index: 2;\n}\n\n.championship-card-premium:hover .championship-overlay {\n  opacity: 1;\n}\n\n.btn-delete-overlay {\n  background: rgba(255, 107, 107, 0.9);\n  color: white;\n  border: 1px solid rgba(255, 107, 107, 0.3);\n  padding: 8px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 700;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  backdrop-filter: blur(10px);\n}\n\n.btn-delete-overlay:hover:not(:disabled) {\n  background: rgba(255, 107, 107, 1);\n  transform: scale(1.05);\n}\n\n.btn-delete-overlay:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Championship Content */\n.championship-content {\n  padding: 20px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  position: relative;\n  z-index: 2;\n}\n\n.championship-header-card {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--line);\n}\n\n.championship-name {\n  font-size: 1.4rem;\n  font-weight: 900;\n  margin: 0;\n  color: var(--fg);\n  letter-spacing: -0.3px;\n  line-height: 1.2;\n}\n\n.championship-date {\n  font-size: 0.85rem;\n  color: var(--muted);\n  font-weight: 600;\n}\n\n/* Formulas Section */\n.formulas-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1;\n}\n\n.formulas-label {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--brand);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.formula-count {\n  background: rgba(192, 255, 3, 0.15);\n  color: var(--brand);\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 800;\n}\n\n.formulas-empty {\n  text-align: center;\n  padding: 20px;\n  color: var(--muted);\n  font-size: 0.9rem;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px dashed var(--line);\n  border-radius: 8px;\n}\n\n.formulas-list-premium {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.formula-badge-premium {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: linear-gradient(135deg, rgba(192, 255, 3, 0.15), rgba(192, 255, 3, 0.08));\n  border: 1px solid rgba(192, 255, 3, 0.3);\n  padding: 6px 10px 6px 12px;\n  border-radius: 999px;\n  transition: all 0.3s ease;\n}\n\n.formula-badge-premium:hover {\n  background: linear-gradient(135deg, rgba(192, 255, 3, 0.2), rgba(192, 255, 3, 0.12));\n  transform: translateY(-1px);\n}\n\n.formula-badge-text {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--brand);\n  letter-spacing: 0.3px;\n}\n\n.formula-badge-remove {\n  background: transparent;\n  border: none;\n  color: var(--brand);\n  cursor: pointer;\n  padding: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  border-radius: 50%;\n}\n\n.formula-badge-remove:hover:not(:disabled) {\n  background: rgba(255, 107, 107, 0.2);\n  color: var(--down);\n  transform: rotate(90deg);\n}\n\n.formula-badge-remove:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Formula Add Premium */\n.formula-add-premium {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-top: auto;\n  padding-top: 12px;\n  border-top: 1px solid var(--line);\n}\n\n.formula-input-premium {\n  flex: 1;\n  background: var(--glass);\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  padding: 10px 14px;\n  color: var(--fg);\n  font-size: 0.9rem;\n  outline: none;\n  transition: all 0.3s ease;\n}\n\n.formula-input-premium:focus {\n  border-color: rgba(192, 255, 3, 0.6);\n  box-shadow: 0 0 0 3px rgba(192, 255, 3, 0.1);\n}\n\n.formula-input-premium:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-add-formula {\n  background: linear-gradient(135deg, var(--brand), #a8ff00);\n  color: #0a0a0a;\n  border: none;\n  padding: 10px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 40px;\n  min-height: 40px;\n  box-shadow: 0 2px 8px rgba(192, 255, 3, 0.3);\n}\n\n.btn-add-formula:hover:not(:disabled) {\n  transform: translateY(-2px) scale(1.05);\n  box-shadow: 0 4px 12px rgba(192, 255, 3, 0.4);\n}\n\n.btn-add-formula:active:not(:disabled) {\n  transform: translateY(0) scale(1);\n}\n\n.btn-add-formula:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Responsive Championships */\n@media (max-width: 768px) {\n  .championships-header {\n    flex-direction: column;\n    gap: 20px;\n    text-align: center;\n  }\n\n  .championships-stats {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .championships-grid-premium {\n    grid-template-columns: 1fr;\n  }\n\n  .form-row-championship {\n    grid-template-columns: 1fr;\n  }\n\n  .championship-hero {\n    height: 160px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
